// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"155":"fac9e276","453":"258b012d","781":"a9f8d56f","850":"6032744f"}[chunkId] + ".chunk.js";
};